import { TreatmentProgressSummaryDto } from '@peartherapeutics/hylia-api-client';

export const treatmentSummary: TreatmentProgressSummaryDto = {
  lessonSummary: {
    completed: 0,
    totalWeeks: 13,
    lessons: [],
    revisitedModuleAmount: 0,
  },
  appointmentCompliances: [],
  lastClinicVisit: '2022-11-01T20:00:00-04:00',
};
